export default "__VITE_ASSET__CEXk1vsl__"